module.exports = __webpack_public_path__ + "img/krebsehalesalat_ingredients.14b1732f.jpg";